/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Daily_LimitInputs */



/**
* | output |
* | --- |
* | "You've reached your daily message limit. Upgrade your plan for unlimited messages." |
*
* @param {Chat_Error_Daily_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_daily_limit = /** @type {((inputs?: Chat_Error_Daily_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Daily_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Du hast dein tägliches Nachrichtenlimit erreicht. Upgrade deinen Plan für unbegrenzte Nachrichten.")
	return /** @type {LocalizedString} */ ("You've reached your daily message limit. Upgrade your plan for unlimited messages.")
});